import ApiResourceManager from '../ApiResourceManager';

export default class ServiceProviderFeatureFlagsManager extends ApiResourceManager {
  /**
   * Provider-scoped feature flags (super admin only). Both endpoints act on the
   * on-behalf-of service provider, so passing an explicit id lets the Partners
   * page edit any partner without re-scoping the dashboard — same contract as
   * ServiceProviderProfileManager.
   */
  get = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/service-provider-feature-flags',
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  update = (flag, enabled, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: `/service-provider-feature-flags/${flag}`,
      data: { enabled },
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });
}
